// packages/api-client/queries/styles/index.ts
import { useQuery, } from "@tanstack/react-query";
export const createTiersQueries = (requests, queryClient) => ({
    useListTiers: (params, options = {}) => useQuery({
        queryKey: ["tiers", params],
        queryFn: () => requests.listTiers(params),
        ...options,
    }),
});
export default createTiersQueries;
//# sourceMappingURL=index.js.map